import { render, staticRenderFns } from "./hdi-index-ticker.vue?vue&type=template&id=22b67be0&scoped=true"
import script from "./hdi-index-ticker.vue?vue&type=script&lang=js"
export * from "./hdi-index-ticker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b67be0",
  null
  
)

export default component.exports